import BasicButton from "components/General/BasicButton";
import {
  useMemo,
  useState,
} from "react";

import { useChatContext , type ChatRoomType,  } from "ChatContext";
import { useGameContext } from "GameContext";
import NewChat from "./NewChat";

function RoomInfoCell({
  chatRoom,
  onClick=()=>null,
} : {
  chatRoom: ChatRoomType,
  onClick?: ()=>void,
}) {
  const { playerMap } = useGameContext();

  const roomName = useMemo(() => {
    if (chatRoom.roomId === "everyone") {
      return "General"
    }

    const [est, roleOrSm] = chatRoom.roomId.split("-")

    if (roleOrSm === "estate") {
      return est === "public" ? "Public Estates" : "Private Estates";
    }

    if (roleOrSm) {
      const epe =  est === "public" ? "Public" : "Private";
      return epe + " " + roleOrSm
    }
    return ""
  }, [chatRoom])

  return (
    <button className="border-black border p-2 bg-[#BCB7A8] hover:bg-[#a19881] duration-100" onClick={onClick}>
      <div className="flex flex-row justify-between items-center gap-2 text-sm">
        { roomName ? (
          <h2 className="text-sm text-start">{ roomName }</h2>
        ) : (
          <div className="flex flex-row items-center text-nowrap overflow-x-auto gap-2">
            <p>Group chat with</p>
            { chatRoom.participants.slice(0,3).map((p,i) => (
              <div key={i} className="flex flex-row gap-1 items-center">
                <p>{playerMap?.get(p)?.playerName}</p>
                <p className="rounded-full border border-black px-2">{playerMap?.get(p)?.estate}</p>
                <p className="rounded-full border border-black px-2">{playerMap?.get(p)?.role}</p>
              </div>
            ))}
            { chatRoom.participants.length > 3 && (
              <p>...</p>
            )}
          </div>
        )}
        <p className="text-xs text-nowrap">{`Members (${chatRoom.participants.length})`}</p>
      </div>
    </button>
  )
}

export default function Chat({
  onRoomClick=(roomId: string) => null,
  onClose=()=>null,
  noback=false,
}: {
  onRoomClick?: (roomId: string) => void,
  onClose?: ()=>void,
  noback?: boolean,
}) {
  const { chatRooms } = useChatContext();

  const [showNewChatMenu, setShowNewChatMenu] = useState(false);

  const chatRoomArray = useMemo(() => {
    return Array.from(chatRooms, ([pId, ply]) => ({ ...ply }))
  }, [chatRooms])

  if (showNewChatMenu) {
    return (
      <NewChat
        onBackClick={()=>setShowNewChatMenu(false)}
        onCreateRoomDone={() => setShowNewChatMenu(false)}
      />
    )
  }

  return (
    <div className="h-full w-full border-2 border-black bg-[#a19881] overflow-y-auto px-2 pb-2 flex flex-col gap-2">
      <div className="w-full text-center text-lg sticky top-0 bg-[#a19881] border-b border-black py-2">Chats</div>

      {!noback && (
        <button className="absolute right-0 top-0 m-2"onClick={onClose}>x</button>
      )}

      {chatRoomArray.length === 0 && (
        <label className="text-center py-4">No chat rooms available.</label>
      )}

      <BasicButton
        text={"New Chat"}
        onClick={() => setShowNewChatMenu(true)}
      />


      <div className="flex flex-col gap-1">
        {chatRoomArray.map((room, i) => (
          <RoomInfoCell key={i} chatRoom={room} onClick={()=>onRoomClick(room.roomId)} />
        ))}
      </div>
    </div>
  )
}
